/**
 * Are we displaying the entire original field
 *
 * For instance, if displayType is original for a table field then we are
 * displaying the entire component. If it is text,
 * circle, square, etc. then that means we are
 * only displaying an invidiual mapped cell from
 * the table or input group. Same is true for dropdown and multi-select fields.
 */
const original = 'original';

/**
 * Primarily used for multi-select field right now.
 */
const horizontal = 'horizontal';

/**
 * Primarily used for table field right now.
 */
const inputGroup = 'inputGroup';

//Selector types: Used for individually mapping cells and options
const text = 'text';
const circle = 'circle';
const square = 'square';
const check = 'check';
const radio = 'radio';

export default {
  original,
  horizontal,
  inputGroup,
  text,
  circle,
  square,
  check,
  radio,
};
